module.exports = __webpack_public_path__ + "img/lion.1f7e3bab.jpg";